import { LockKeyhole } from 'lucide-react';
import { forwardRef } from 'react';
import { DataState } from '../data-state';
import type { PermissionDeniedStateProps } from './permission-denied-state.types';

export const PermissionDeniedState = forwardRef<HTMLDivElement, PermissionDeniedStateProps>(
  ({ scale = 'page', ...props }, ref) => (
    <DataState
      ref={ref}
      {...props}
      data-state="permission-denied"
      scale={scale}
      tone="neutral"
      icon={<LockKeyhole className="h-[18px] w-[18px]" aria-hidden="true" />}
    />
  ),
);

PermissionDeniedState.displayName = 'PermissionDeniedState';
